import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { boldFont, OwnerlscValue, TrackingInfoGrid } from '../../styles';

function SummaryItem({ title, value, isLink = false }) {
  return (
    <Grid style={TrackingInfoGrid} item xs={2} sm={4} md={4}>
      <Grid style={boldFont}>{title}</Grid>
      {!isLink && <Grid style={OwnerlscValue}>{value || ''}</Grid>}
      {isLink && (
        <Grid style={OwnerlscValue}>
          {
            <a href={value || null} rel="noreferrer" target="_blank">
              {value ? 'Link' : 'N/A'}
            </a>
          }
        </Grid>
      )}
    </Grid>
  );
}

function TrackingFileSummary({ data, userSiteData, isLoading }) {
  const { t } = useTranslation();

  return (
    <>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <SummaryItem
          title={`${t('Title')}:`}
          value={`${data.Title} (${data.ID})`}
        />
        <SummaryItem
          title={`${t('Creator')}:`}
          value={`${userSiteData.FirstName} ${userSiteData.LastName} (${userSiteData.SiteName})`}
        />
        <SummaryItem
          title={`${t('Product_Family')}:`}
          value={data.ProductName}
        />
        <SummaryItem title={`${t('Description')}:`} value={data.Description} />
        <SummaryItem
          title={`${t('P/ECR URL')}:`}
          value={data.WindchillECRUrl}
          isLink
        />
      </Grid>
    </>
  );
}
export default TrackingFileSummary;
